import {
  createStyles,
  makeStyles,
  TableCell,
  Theme,
  withStyles,
} from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: theme.palette.background.default,
      color: theme.palette.secondary.light,
    },
    table: {
      minWidth: 650,
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      marginTop: 16,
      marginBottom: 16,
    },
    addButton: {
      textTransform: 'none',
      fontWeight: 600,
      borderRadius: 8,
      boxShadow: 'none',
      paddingLeft: 16,
      paddingRight: 16,
    },
    filterCard: {
      padding: 16,
      borderRadius: 12,
      marginBottom: 16,
      border: '1px solid rgba(0, 0, 0, 0.08)',
    },
    statusFilterBar: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: 8,
      marginBottom: 8,
    },
    statusPill: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      padding: '4px 10px',
      borderRadius: 999,
      border: '1px solid rgba(0, 0, 0, 0.12)',
      background: '#fff',
      cursor: 'pointer',
      fontFamily: 'inherit',
      color: 'rgba(0, 0, 0, 0.75)',
      transition: 'background 0.15s ease, box-shadow 0.15s ease',
      '&:hover': {
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.12)',
      },
    },
    statusPillPrimary: {
      fontSize: 13,
      fontWeight: 600,
      padding: '6px 12px',
    },
    statusPillSecondary: {
      fontSize: 12,
      fontWeight: 500,
      opacity: 0.85,
    },
    statusPillAll: {
      fontSize: 13,
      fontWeight: 600,
      padding: '6px 12px',
    },
    statusPillActive: {
      color: '#fff',
      background: 'rgba(0, 0, 0, 0.75)',
      borderColor: 'rgba(0, 0, 0, 0.75)',
      '& $statusPillDot': {
        background: '#fff !important',
      },
    },
    statusPillDot: {
      width: 8,
      height: 8,
      borderRadius: '50%',
      display: 'inline-block',
    },
    statusPillLabel: {
      lineHeight: 1.4,
    },
    statusPillCount: {
      fontWeight: 700,
      fontSize: 'inherit',
    },
    filterLabel: {
      fontSize: 12,
      fontWeight: 600,
      color: 'rgba(0, 0, 0, 0.6)',
      marginBottom: 4,
      display: 'block',
    },
    toggleField: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 0,
    },
    filter: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '1%',
    },
    item: {
      paddingRight: '2%',
      minWidth: '200px',
    },
    formTitles: {
      fontWeight: 'bolder',
    },
  }),
);

export const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.background.default,
    },
    body: {
      fontSize: 14,
    },
  }),
)(TableCell);
